import type { SupplierThumb } from './types';

export default function SupplierAvatars({ suppliers }: { suppliers: SupplierThumb[] }) {
    if (!suppliers.length) {
        return <span className="text-xs text-gray-400">—</span>;
    }

    const visible = suppliers.slice(0, 5);
    const remaining = suppliers.length - visible.length;

    return (
        <div className="flex items-center -space-x-2">
            {visible.map((s) =>
                s.logo_url ? (
                    <img
                        key={s.label}
                        src={s.logo_url}
                        alt={s.label}
                        title={s.label}
                        className="h-7 w-7 rounded-full border-2 border-white object-cover shadow-sm ring-1 ring-gray-200"
                    />
                ) : (
                    <span
                        key={s.label}
                        title={s.label}
                        className="inline-flex h-7 w-7 items-center justify-center rounded-full border-2 border-white text-[10px] font-bold text-white shadow-sm ring-1 ring-gray-200"
                        style={{ backgroundColor: s.thumbnail_color }}
                    >
                        {s.abbreviation}
                    </span>
                ),
            )}
            {remaining > 0 && (
                <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border-2 border-white bg-primary-lighter text-[10px] font-bold text-primary-dark ring-1 ring-gray-200">
                    +{remaining}
                </span>
            )}
        </div>
    );
}
